import { render, staticRenderFns } from "./consume-log-details.vue?vue&type=template&id=56f9c344&scoped=true&"
import script from "./consume-log-details.vue?vue&type=script&lang=js&"
export * from "./consume-log-details.vue?vue&type=script&lang=js&"
import style0 from "./consume-log-details.vue?vue&type=style&index=0&id=56f9c344&prod&lang=scss&"
import style1 from "./consume-log-details.vue?vue&type=style&index=1&id=56f9c344&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f9c344",
  null
  
)

export default component.exports